import { render, staticRenderFns } from "./GameConfig.vue?vue&type=template&id=f0f5caf0&scoped=true&"
import script from "./GameConfig.vue?vue&type=script&lang=js&"
export * from "./GameConfig.vue?vue&type=script&lang=js&"
import style0 from "./GameConfig.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameConfig.vue?vue&type=style&index=1&lang=css&"
import style2 from "./GameConfig.vue?vue&type=style&index=2&id=f0f5caf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f5caf0",
  null
  
)

export default component.exports